import React, { Component } from 'react';
import { IHomePageBoxAnnouncementProps } from '../../models/components/homepage-box-announcements';
import { IAppState } from '../../models/action/core';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { Redirect } from 'react-router-dom';
import * as Actions from '../../store/actions/profile';
import { IProfileProps } from '../../models/pages/profile';
import Translator from '../../core/i18n';
import Loading from '../loading/loading';
import ContentLoader from 'react-content-loader';
import { IPreference } from '../../models/action/profile';
import * as AnnouncementActions from '../../store/actions/announcement';
import ShowAllButton from '../show-all-button/main';
import { Common } from '../../core/common';

const T = Translator.create();
let _common: Common;
const _logger = Log.create('Homepage Box Announcement');
export class CAnnouncement extends Component<IHomePageBoxAnnouncementProps & IProfileProps> {
    state = {
        redirect: false,
        redirectUrl: '/',
        boxItems: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
        boxItemsVisual: [false, false, false, false, false, false],
        boxCount: 0
    };
    constructor(props: any) {
        super(props);
        _common = new Common();

    }

     public handleChange = () => {
            const { userPreferences, dispatch } = this.props;
            const { boxItems, boxItemsVisual } = this.state;
    
            const updateBoxItemsVisual = (items: string[]) => {
                items.forEach(item => {
                    boxItemsVisual[parseInt(item, 10)] = true;
                });
            };
    
            const updatePreferences = (items: string[]) => {
                const preferencesValue = items.toString();
                const preferenceData = {
                    preferences: [{ name: 'home.index.boxallowed', value: preferencesValue }]
                };
                dispatch(Actions.addOrUpdatePreferencesAction(preferenceData));
            };
    
            if (userPreferences && userPreferences.length > 0) {
                const preference = userPreferences.find((pref: any) => pref.name === 'home.index.boxallowed');
                if (preference && preference.value) {
                    const updatedBoxItems = preference.value.split(',').filter(item => item !== '5');
                    this.setState({ boxItems: updatedBoxItems });
                    updateBoxItemsVisual(updatedBoxItems);
                    updatePreferences(updatedBoxItems);
                }
            } else {
                const updatedBoxItems = boxItems.filter(item => item !== '5');
                this.setState({ boxItems: updatedBoxItems });
                updateBoxItemsVisual(updatedBoxItems);
                updatePreferences(updatedBoxItems);
            }
    };

    public async onAnnouncementClick(announcementId: string, index: number) {
        await this.triggerAnnouncementModal().then(() => {
            this.props.dispatch(AnnouncementActions.GetLoginAnnouncementById(announcementId, 'getLoginAnnouncementModal', 'get', index));
        });
    }

    public async triggerAnnouncementModal() {
        this.props.triggerAnnouncementModal();
    }

    onClickNavigateUrl = (announcementId?: string, tabIndex?: number) => (event: any) => {
        let url = 'u/Announcement/Index';
        if (announcementId && tabIndex) {
            url = url + '?announcementId=' + announcementId + '&tabIndex=' + tabIndex;
        }
        this.setState({ redirect: true, redirectUrl: url });
    }

    componentDidMount() {
        // let lastAnnouncementId;

        if (this.props.userPreferences!.length > 0) {
            if (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount')) {
                this.setState({
                    boxCount: (this.props.userPreferences!.find(pref => pref.name === 'home.index.boxcount') as IPreference).value
                });
            }
        }
    }

    public render() {
        const initialFormValues = {
            ...this.props.profileData,
            userPreferences: this.props.userPreferences,
            handleChange: this.handleChange
        };
        const loadingSpaces = 74;
        const loadingSizes = this.state.boxCount === 2 ? '0 0 540 300' : '0 0 350 300';
        if (this.state.redirect) {
            return <Redirect push={true} to={window.appSettings.DEFAULT_URL + '/' + this.state.redirectUrl} />;
        }
        return (
            <div className="white-box student-discussions ">
                <div className="d-flex justify-content-between white-box-header">
                    <div>
                        <span className='bodytext1 fw-500' tabIndex={0}>
                            {T.t('r_home_index_box_announcement')}
                            <span className='badge badge-pill badge-light py-1 px-2' style={{marginInlineStart: "0.5rem"}}  tabIndex={0}>{this.props.announcements ? this.props.announcements.length : '0'}</span>
                        </span>
                    </div>
                    <div className="align-self-center">
                        <i
                            className="material-icons mr-2 align-middle"
                            onClick={this.handleChange}
                            style={{ cursor: 'pointer' }}
                        >
                            visibility
                        </i>
                        <ShowAllButton redirectUrl='/u/Announcement/Index'/>
                    </div>
                </div>
                <Loading spinnerId={'getHomeBoxAnnouncement'}>
                    <div style={{ backgroundColor: '#fbfaf6' }}>
                        <ContentLoader
                            speed={2}
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                            viewBox={loadingSizes}
                            style={{ width: '100%' }}
                        >
                            <rect x="16" y="24" rx="3" ry="3" width="315" height="10" />
                            <rect x="16" y="44" rx="3" ry="3" width="120" height="8" />
                            <rect x="16" y="60" rx="3" ry="3" width="290" height="7" />
                            <rect x="16" y="74" rx="3" ry="3" width="60" height="7" />

                            <rect x="16" y={24 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="120" height="8" />
                            <rect x="16" y={60 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="290" height="7" />
                            <rect x="16" y={74 + loadingSpaces} rx="3" ry={3 + loadingSpaces} width="60" height="7" />

                            <rect x="16" y={24 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="120" height="8" />
                            <rect x="16" y={60 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="290" height="7" />
                            <rect x="16" y={74 + loadingSpaces * 2} rx="3" ry={3 + loadingSpaces * 2} width="60" height="7" />

                            <rect x="16" y={24 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="315" height="10" />
                            <rect x="16" y={44 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="120" height="8" />
                            <rect x="16" y={60 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="290" height="7" />
                            <rect x="16" y={74 + loadingSpaces * 3} rx="3" ry={3 + loadingSpaces * 3} width="60" height="7" />
                        </ContentLoader>
                    </div>
                </Loading>
                <ul id="getHomeBoxAnnouncement_Content" className="white-box-body">
                    {this.props.announcements && this.props.announcements.length > 0 ? (
                        this.props.announcements.map((announcement, index) => {
                            return (
                                <li onClick={this.onAnnouncementClick.bind(this, announcement.announcementId!, index)} key={index} className="media mb-3">
                                    <div className="media-body breakableTextStyle">
                                        <h5 tabIndex={0}
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.onAnnouncementClick(announcement.announcementId!, index)
                                            }
                                        }}
                                        className={ (!_common.isArabic(announcement?.subject, document.body.getAttribute('dir')) ? 'arabic-text-direction mt-0 homebox-clickable-item' : 'mt-0 homebox-clickable-item')}
                                        >📍 {announcement?.subject
                                            ? announcement.subject.length > 80
                                              ? announcement.subject.slice(0, 80) + "..."
                                              : announcement.subject
                                            : ""}
                                            </h5>
                                        <span>
                                            <b className="breakableTextStyle"  style={{ float: (document.body.getAttribute('dir') == 'rtl' && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'left': 'unset' , direction: (document.body.getAttribute('dir') == 'rtl'  && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'ltr': 'rtl'}} tabIndex={0}>{(announcement.fromDisplayName) ? (announcement?.fromDisplayName.length > 120) ? announcement?.fromDisplayName.slice(0,120) + '...' : announcement?.fromDisplayName : '' }</b>
                                            <div id="announcementBody" className="announcement-body" tabIndex={0}>
                                                <span style={{lineHeight: 1.145, float: (document.body.getAttribute('dir') == 'rtl' && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'left': 'unset' , direction: (document.body.getAttribute('dir') == 'rtl'  && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'ltr': 'rtl'}} dangerouslySetInnerHTML={{ __html: (announcement.body) ? (announcement.body.length > 120) ? announcement.body.slice(0, 120).replace(/<\/?[^>]+(>|$)/g, '') + ' ...' : announcement.body.replace(/<\/?[^>]+(>|$)/g, '') : '' }} />
                                            </div>
                                        </span>
                                        <i className="mt-1" tabIndex={0} style={{ minWidth:"100%",
                                            float: (document.body.getAttribute('dir') == 'rtl' && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'left': 'unset' ,
                                            direction: (document.body.getAttribute('dir') == 'rtl'  && !_common.isArabic(announcement.body?.replace(/<\/?[^>]+(>|$)/g, ''))) ? 'ltr': 'unset'}}>{announcement.startDate ? this.props.diffDate(announcement.startDate, announcement.serverTime) : ''}</i>
                                    </div>
                                </li>
                            );
                        })
                    ) : (
                        <p tabIndex={0}>{T.t('r_home_box_announcement_not_found')}</p>
                    )}
                </ul>

            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: IHomePageBoxAnnouncementProps): IHomePageBoxAnnouncementProps => {
    if (!state) {
        return ownProps;
    }

    const newProps: IHomePageBoxAnnouncementProps = Object.assign({}, ownProps, {
        announcements: state.announcement.homePageAnnouncements,
        userPreferences: state.profile.userPreferences.preferences
    });

    return newProps;
};

const Announcement = connect(mapStateToProps)(CAnnouncement);

export default Announcement;
